// 13 Treasures of Britain random-teleport helper. Pure. No React, no
// Three.js.
//
// ── Codex (13 Treasures of Britain, Artifact. Relic) ──
//   "When picked up, bearer's controller draws a card. Teleport the
//    Treasures to the top of a RANDOM site or void."
//
// After the on_pickup draw resolves, the Treasures jump off their
// bearer to the top of a uniformly random site OR void. Every grid cell
// is either a site or a void (an empty cell exposes the void region per
// `regions.js`), so the eligible set is simply every cell on the board.
//
// Determinism note (P2P): the on_pickup trigger fires on exactly ONE
// client (the equip choke point), so the random cell is rolled once
// there. The runtime re-spawns the Treasures at that cell through the
// synced place primitive, whose broadcast carries the chosen position.
// the opponent never rolls its own cell. This helper only owns the
// dice; the move sync is the runtime's job.

/**
 * Pick a uniformly random board cell (the "random site or void"
 * destination). All cells are eligible because every cell is either a
 * site or a void.
 *
 * @param totalCols  grid column count
 * @param totalRows  grid row count
 * @param rng        () => number in [0, 1). Injected so callers can seed it
 * @returns {{ col, row } | null}  null when the grid is degenerate
 */
export function pickRandomSiteOrVoidCell(totalCols, totalRows, rng) {
  if (!Number.isInteger(totalCols) || !Number.isInteger(totalRows)) return null;
  if (totalCols <= 0 || totalRows <= 0) return null;
  const roll = typeof rng === 'function' ? rng() : Math.random();
  const index = Math.floor(roll * totalCols * totalRows);
  // Clamp defends against rng() returning exactly 1 (out of contract but
  // cheap to guard) which would index one cell past the grid.
  const clamped = Math.min(index, totalCols * totalRows - 1);
  return { col: clamped % totalCols, row: Math.floor(clamped / totalCols) };
}
